module.exports = __webpack_public_path__ + "img/thumb_03.4f0d5980.jpg";